import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getRanking } from "@/lib/api";

const medalla = (p) => (p === 1 ? "🥇" : p === 2 ? "🥈" : p === 3 ? "🥉" : null);

export default function RankingPanel() {
  const { data } = useQuery({ queryKey: ["ranking"], queryFn: getRanking });
  const rows = data?.ranking || [];
  const umbral = data?.umbral || 30;
  const totalAlumnos = data?.total_alumnos ?? 0;
  const activo = totalAlumnos >= umbral;

  return (
    <div data-testid="ranking-panel">
      <div className="main-head">
        <div>
          <h1>Ranking de alumnos</h1>
          <p className="sub">Los que más avanzan, más facturan. {data?.mi_puesto ? `Vas en el puesto #${data.mi_puesto}.` : "Completa lecciones para entrar en el ranking."}</p>
        </div>
      </div>
      <div data-testid="ranking-aviso-30" style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", borderRadius: 12, marginBottom: 18, border: `1px solid ${activo ? "var(--line)" : "var(--gold)"}`, background: activo ? "rgba(255,255,255,.02)" : "rgba(197,164,90,.10)" }}>
        <span style={{ fontSize: 18 }}>🏆</span>
        <span style={{ fontSize: 13, color: activo ? "var(--muted)" : "var(--cream)" }}>
          {activo
            ? `El ranking está activo · ${totalAlumnos} alumnos.`
            : `El ranking se activa a partir de ${umbral} alumnos. Ahora mismo hay ${totalAlumnos}. ¡Sigue avanzando, se actualizará pronto!`}
        </span>
      </div>
      {rows.length === 0 ? (
        <p style={{ color: "var(--muted)" }}>Todavía no hay alumnos en el ranking. ¡Sé el primero en completar lecciones!</p>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 8, maxWidth: 640 }}>
          {rows.map((r) => (
            <div key={r.puesto} data-testid={`ranking-row-${r.puesto}`}
              style={{
                display: "flex", alignItems: "center", gap: 16, padding: "14px 18px", borderRadius: 12,
                border: r.is_me ? "1px solid var(--gold)" : "1px solid var(--line)",
                background: r.is_me ? "rgba(197,164,90,0.10)" : "rgba(255,255,255,0.02)",
              }}>
              <div style={{ minWidth: 34, textAlign: "center", fontSize: medalla(r.puesto) ? 22 : 15, fontWeight: 700, color: "var(--gold)" }}>
                {medalla(r.puesto) || r.puesto}
              </div>
              <div style={{ width: 38, height: 38, borderRadius: "50%", background: "var(--ink)", border: "1px solid var(--gold)", display: "grid", placeItems: "center", color: "var(--gold)", fontWeight: 700 }}>{r.avatar}</div>
              <div style={{ flex: 1 }}>
                <div style={{ color: "var(--cream)", fontWeight: 600, fontSize: 14.5 }}>{r.nombre}{r.is_me && <span style={{ color: "var(--gold)", fontSize: 12 }}> · tú</span>}</div>
                <div style={{ color: "var(--muted)", fontSize: 12 }}>{r.lecciones} lecciones · {r.pct}% · 🔥 {r.racha} días</div>
              </div>
              <div style={{ textAlign: "right" }}>
                <div style={{ color: "var(--gold)", fontWeight: 700, fontSize: 15 }} data-testid={`ranking-insignias-${r.puesto}`}>🏅 {r.insignias}</div>
                <div style={{ color: "var(--muted)", fontSize: 11 }}>insignias</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
